import type { SidebarComponent } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './sidebar.module.css'
import { SidebarContext } from './sidebar-context.js'
import { SidebarSuggestion } from './sidebar-suggestion.js'

/**
 * The rail's Assist tool: suggestions first, then the musical context, each under its own heading.
 * It is the `Suggestions` tool (the persisted tool name is unchanged). Context is not listed in More panels,
 * so it has one home.
 */
export const SidebarAssistPanel: FC<SidebarComponent> = props => (
  <>
    <h3 className={styles.sectionHeader}>Suggestions</h3>
    <SidebarSuggestion {...props} />
    <h3 className={styles.sectionHeader}>Context</h3>
    <SidebarContext {...props} />
  </>
)
